import { Avatar } from '@mui/material';
import { getDatabase, ref, remove } from 'firebase/database';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';

const BotigaOptions = (productes) => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const options = {
        enableNestedDataAccess: '.',
        filter: false,
        download: false,
        print: false,
        filterType: 'checkbox',
        onRowClick: (rowData) => {
            navigate(`/botiga/${rowData[0]}`);
        },
        onRowsDelete: (rowsDeleted) => {
            rowsDeleted.data.forEach(async (item) => {
                const db = getDatabase();
                const reference = ref(
                    db,
                    'botiga/' + productes[item.dataIndex].id
                );
                await remove(reference);

                enqueueSnackbar('Producte eliminat', {
                    variant: 'success',
                });
            });
        },
        textLabels: {
            body: {
                noMatch: 'No hi ha productes',
                toolTip: 'Ordenar',
                columnHeaderTooltip: (column) =>
                    `${'Ordenat per'} ${column.label}`,
            },
            pagination: {
                next: 'Següent pàgina',
                previous: 'Pàgina anterior',
                rowsPerPage: 'Files per pàgina:',
                displayRows: 'de', // 1-10 of 30
            },
            toolbar: {
                search: 'Cercar',
                downloadCsv: 'Descarregar CSV',
                print: 'Imprimir',
                viewColumns: 'Veure columnes',
                filterTable: 'Filtrar taula',
            },
            filter: {
                title: 'FILTRES',
                reset: 'resetejar',
                all: 'Tots',
            },
            viewColumns: {
                title: 'Mostrar columnes',
            },
            selectedRows: {
                text: 'Fila/es eliminades',
                delete: 'Eliminar',
            },
        },
    };
    return options;
};

const columns = [
    {
        name: 'id',
        label: 'ID',
        options: {
            filter: false,
            sort: true,
            display: false,
        },
    },
    {
        name: 'imatge',
        label: 'Imatge',
        options: {
            filter: false,
            sort: true,
            customBodyRender: (value) => (
                <Avatar src={value} width={30} height={30} />
            ),
        },
    },
    {
        name: 'nom',
        label: 'Nom',
        options: {
            filter: false,
            sort: true,
        },
    },
    {
        name: 'preu',
        label: 'Preu',
        options: {
            filter: false,
            sort: true,
            customBodyRender: (value) => value + ' €',
        },
    },
    {
        name: 'order',
        label: 'Ordre',
        options: {
            filter: false,
            sort: true,
        },
    },
];

export { BotigaOptions, columns };
